<template>
<div class="bg-gray-100">
    <header class="bg-white p-6 mb-6">
        <nav class="flex justify-between items-center">
            <div>☰ Menü</div>
            <!-- Authentication -->
            <form @submit.prevent="logout">
                <jet-dropdown-link as="button">
                    Logout
                </jet-dropdown-link>
            </form>
        </nav>
    </header>


    <main class="px-4">
        <slot></slot>
    </main>
     <!-- Footer with contact information -->
     <footer class="bg-gray-200 p-4 mt-4 rounded-lg max-w-3xl mx-auto">
            <div class="flex justify-between">
                <div>
                    <div>Schreib uns jederzeit</div>
                    <a href="mailto:hallo@stall.de" class="underline">hallo@stall.de</a>
                </div>
                <div>
                    <!-- Placeholder for the octopus image -->
                    <img src="https://placehold.co/100x100" alt="An octopus holding a phone and a wrench, implying customer support" class="rounded-full">
                </div>
            </div>
        </footer>

        <footer class="bg-white px-6 py-4 mt-8">
            <div class="flex flex-col md:flex-row justify-between">
                <div class="flex flex-col mb-4 md:mb-0">
                    <a href="#" class="hover:text-purple-300">Impressum</a>
                    <a href="#" class="hover:text-purple-300">Datenschutzerklärung</a>
                    <a href="#" class="hover:text-purple-300">Allgemeine Geschäftsbedingungen</a>
                </div>
                <div class="flex items-center">
                    <p class="text-sm">&copy; 2023 hof.services UG (haftungsbeschränkt) | All rights reserved</p>
                </div>
            </div>
        </footer>

</div>
</template>

<script>
import JetApplicationMark from '@/Jetstream/ApplicationMark'
import JetBanner from '@/Jetstream/Banner'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetNavLink from '@/Jetstream/NavLink'
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink'
import { MailIcon } from '@heroicons/vue/solid'

export default {
    components: {
    JetApplicationMark,
    JetBanner,
    JetDropdown,
    JetDropdownLink,
    JetNavLink,
    JetResponsiveNavLink,
    MailIcon,
},

    data() {
        return {
            showingNavigationDropdown: false,
            links: [
                {
                    name: 'Start',
                    route: 'dashboard'
                },
                {
                    name: 'Pferde',
                    route: 'horses.index'
                },
                {
                    name: 'Produkte',
                    route: 'products.index'
                },
                {
                    name: 'Ställe',
                    route: 'stables.index'
                },
                {
                    name: 'Kunden',
                    route: 'customers.index'
                },
                {
                    name: 'E-Mail',
                    route: 'email.index'
                },
                {
                    name: 'Sepa',
                    route: 'sepa.index'
                },
            ],
        }
    },
    methods: {
        logout() {
            this.$inertia.post(route('logout'));
        },
    }
}
</script>
